<div class="container-fuid default-boxrounded">
  <div class="modal-header import-export d-flex row-cols-12 p-0">
    <div class="col-11">
      <b class="d-block d-lg-none px-3 pt-4 pb-2" [translate]="modalTitleTranslationKey"></b>
      <h3 class="d-none d-lg-block title" [translate]="modalTitleTranslationKey"></h3>
    </div>
    <div class="col-1">
      <span class="d-block title float-end">
        <button class="btn cloudDocumentsHeader action-button border-0 p-0 me-3" (click)="closeDialog()" type="button">
          <i class="bi bi-x-lg bi-large"></i>
        </button>
      </span>
    </div>
  </div>

  <div class="ms-0 col-12 row row-cols-12 sourceHeight">
    <div class="col-3 p-0">
      <app-cloud-document-source-sidebar>
        <input search
          type="text"
          class="form-control"
          autocomplete="off"
          [disabled]="!hasSelectedProvider"
          placeholder="{{ 'CloudLocations.Search' | translate }}"
          [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)"
          [required]="isHyarchisSource"
          [minlength]="isHyarchisSource ? 3 : null"
          popupClass="dropdown-menu-person-dialog">
        </app-cloud-document-source-sidebar>
      </div>

      <div class="col-9 p-0">
        @if (!hasSelectedProvider) {
          <div class="noSource d-flex align-items-center justify-content-center w-100 h-100">
            <span translate="CloudLocations.PleaseSelectSource"></span>
          </div>
        }

        @if (hasSelectedProvider) {
          <div>
            <app-cloud-document-file-browser></app-cloud-document-file-browser>
            <button class="btn btn-link collapse-btn" (click)="toggleCloudDetails()"
              [attr.aria-label]="detailsCollapsed ? 'Toon details' : 'Verberg details'">
              <i class="bi" [ngClass]="{'bi-chevron-left': detailsCollapsed, 'bi-chevron-right': !detailsCollapsed}"></i>
            </button>
            @if (!detailsCollapsed) {
              <div class="col-4 cloudDetails float-start">
                <app-cloud-document-details-panel></app-cloud-document-details-panel>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
